/**
 * The Experiments page as the URL holds it: which experiment is open beside
 * the list. Nothing else of the page lives anywhere.
 */
export type ExperimentsSearch = {
  experiment?: string
}

/** Whatever the URL says, a page that can be drawn: it never throws. */
export function parseExperimentsSearch(search: Record<string, unknown>): ExperimentsSearch {
  const parsed: ExperimentsSearch = {}
  // A document id, as far as its shape goes: the server says whether it is one.
  if (typeof search.experiment === "string" && /^[a-z0-9]{8,64}$/i.test(search.experiment)) {
    parsed.experiment = search.experiment
  }
  return parsed
}
